import React, { useState } from 'react';
import RevisionModal from './RevisionModal';
import { useTranslation } from '../context/TranslationContext';
import './RevisionButton.css';

interface RevisionButtonProps {
  requestId: string;
  onRevisionRequested: () => void;
}

const RevisionButton: React.FC<RevisionButtonProps> = ({
  requestId,
  onRevisionRequested
}) => {
  const { t } = useTranslation();
  const [isRevisionModalOpen, setIsRevisionModalOpen] = useState(false);

  const handleRevisionClick = () => {
    setIsRevisionModalOpen(true);
  };

  const handleRevisionRequested = () => {
    onRevisionRequested();
  };

  return (
    <>
      <button
        className="revision-btn"
        onClick={handleRevisionClick}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/>
          <path d="M21 3v5h-5"/>
          <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/>
          <path d="M3 21v-5h5"/>
        </svg>
        {t('components.revision_button.request_revision')}
      </button>

      <RevisionModal
        isOpen={isRevisionModalOpen}
        onClose={() => setIsRevisionModalOpen(false)}
        requestId={requestId}
        onRevisionRequested={handleRevisionRequested}
      />
    </>
  );
};

export default RevisionButton; 